iScreenWizard.controller('KandidaatgegevensController', function ($scope, $state, $mdDialog, ErrorHandler, Ajax, Dictionary, userService, Opleidingsniveau, Groepscode, Taal, nieuweTestafnameService, Klantorganisatie) {

    $scope.userService = userService;
    $scope.testafname = nieuweTestafnameService.model;
    $scope.opleidingsniveaus = [];
    $scope.talen = [];
    $scope.groepscodes = [];
    $scope.useExistingGroupCode = true;

    Klantorganisatie.current().then(function (organisatie) {
        $scope.klantorganisatie = organisatie;
    });

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        Opleidingsniveau.all().then(function (opleidingsniveaus) {
            $scope.opleidingsniveaus = opleidingsniveaus;
        });
        Taal.all().then(function (talen) {
            $scope.talen = talen;
        });
        $scope.testafname.group_code = '';
        Groepscode.all().then(function (groepscodes) {
           $scope.groepscodes = groepscodes;
           if (groepscodes.length < 1) {
               $scope.useExistingGroupCode = false;
           }
        });
    };

    $scope.createNewGroupCode = function() {
        $scope.useExistingGroupCode = false;
    };

    $scope.dontCreateNewGroupCode = function() {
        $scope.testafname.group_code = '';
        $scope.useExistingGroupCode = true;
    };

    $scope.saveKandidaatgegevens = function() {
        var mock = {
            data: {
                _errors: []
            }
        };
        if (!$scope.testafname.kandidaat.opleidingsniveau) {
            mock.data._errors.push(Dictionary.translate('app.select_education_level', true));
        }
        if (!$scope.testafname.kandidaat.taal) {
            mock.data._errors.push(Dictionary.translate('app.select_language', true));
        }
        if (ErrorHandler.hasErrors(mock)) {
            ErrorHandler.showDialog(mock);
        } else {
            $scope.testafname.rapporttemplate = null;
            nieuweTestafnameService.SaveState();
            $state.go('nieuwe-testafname/selecteer-rapport');
        }
    };

});